function AccordionInline(containerObject) {
	/* THIS FIX */
	var _this = this;

	/* PRIVATE CONSTANTS */

	/* PRIVATE VARIABLES */
	var originalContentBlock;
	var expandedContentBlock;
	var toggle;
	var toggleRestoreSibling;
	

	/* PUBLIC PROPERTIES */
	this.container = null;
	this.inited = false;


	/* PRIVATE FUNCTIONS */
	function _construct() {
		_this.container = containerObject;
		_this.init();
	}
	
	
	/*
	 * Move content up one level and append to sibling of toggle container
	 */ 
	function initContent(){
		// create element for remembering position where toggle should be placed
		toggleRestoreSibling = $('<span>');
		toggle.before(toggleRestoreSibling);
		
		// parse content
		var contentRaw = _this.container.data('content');
		var contentHtml = $.parseHTML(String(contentRaw).trim());
		
		// create content block
		expandedContentBlock = $('<div>');
		expandedContentBlock.addClass('accordion-inline-expanded-content');
		expandedContentBlock.append(contentHtml);
		
		// append block
		originalContentBlock.after(expandedContentBlock);
	}
	

	function toggleContentHandler() {
		toggle.click(function (e) {
			e.preventDefault();
			
			toggle.toggleClass('active');
			originalContentBlock.toggleClass('no-margin-bottom');
			
			expandedContentBlock.toggle({
				complete: function() {
					if(toggle.hasClass('active')) {
						toggle.attr('title', toggle.data('labelCollapsed'));
						toggle.text(toggle.data('labelCollapsed'));
						// move toggle element
						expandedContentBlock.children().last().append(toggle); 
					}else{
						toggle.attr('title', toggle.data('labelExpanded'));
						toggle.text(toggle.data('labelExpanded'));
						// move toggle element
						toggleRestoreSibling.append(toggle);
					}
				},
				duration: 0
			});

		});
	}
	

	/* PUBLIC FUNCTIONS */
	this.init = function () {
		if (!_this.inited) {
			// init
			toggle = $('.accordion-inline-toggle', _this.container);
			originalContentBlock = _this.container.parent();
			
			initContent();
			toggleContentHandler();

			_this.inited = true;
		}
	};


	/* INIT CONSTRUCTOR */
	_construct();
}


/* PUBLIC CONSTANTS */
